import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from '@wegic/ui';
import '@wegic/ui/dist/components/Button/index.css';
import '@wegic/ui/dist/components/Modal/index.css';
import { useCallback, useEffect, useMemo, useState } from 'react';
import UsageNotifyImg from '@/assets/images/Credits/UasgeNotify.png';
import { useNotify } from '@/helpers/notify/useNotify';
import { openSettingsModal, SettingsModalSource, SettingsTab } from '@/helpers/settingsModal';
import { UserNotify } from '@/services/user/const';
import { useUserStore } from '@/stores/user';
import { useUserNotifyStore } from '@/stores/userNotify';
import styles from './index.module.less';
// 只有在此时间之前注册的用户才会显示弹窗
const CREDIT_CARE_CUTOFF_DATE = new Date('2026-01-20T14:31:28').getTime();
/**
 * 解析后端返回的日期格式 "2026-01-21 10:26:12.0"
 */ function parseCreateDate(dateStr) {
    const normalized = dateStr.replace(' ', 'T').replace(/\.0$/, '');
    return new Date(normalized).getTime();
}
export function CreditCareModal(props) {
    const { externalVisible, onExternalClose } = props;
    const [internalVisible, setInternalVisible] = useState(false);
    const needNotify = useUserNotifyStore((state)=>state.notifies[UserNotify.UserCreditLog]);
    const initialized = useUserNotifyStore((state)=>state.initialized);
    const createDate = useUserStore((state)=>{
        var _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.createDate;
    });
    const [, setNotifyValue] = useNotify(UserNotify.UserCreditLog);
    // 是否使用外部控制
    const isExternalControlled = externalVisible !== undefined;
    const visible = isExternalControlled ? externalVisible : internalVisible;
    const isEligible = useMemo(()=>{
        if (!createDate) {
            return false;
        }
        return parseCreateDate(createDate) < CREDIT_CARE_CUTOFF_DATE;
    }, [
        createDate
    ]);
    useEffect(()=>{
        // 只有内部控制时才自动显示
        if (!isExternalControlled && initialized && needNotify && isEligible) {
            setInternalVisible(true);
        }
    }, [
        initialized,
        needNotify,
        isEligible,
        isExternalControlled
    ]);
    const dismissModal = useCallback(async ()=>{
        if (isExternalControlled) {
            onExternalClose === null || onExternalClose === void 0 ? void 0 : onExternalClose();
        } else {
            setInternalVisible(false);
            try {
                await setNotifyValue(false);
            } catch  {
            // ignore
            }
        }
    }, [
        isExternalControlled,
        onExternalClose,
        setNotifyValue
    ]);
    const handleLearnMore = useCallback(()=>{
        dismissModal();
        openSettingsModal({
            initialTab: SettingsTab.Usage,
            source: SettingsModalSource.CreditCare
        });
    }, [
        dismissModal
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        className: styles['credit-care-modal'],
        visible: visible,
        onCancel: dismissModal,
        unmountOnExit: true,
        hideFooter: true,
        title: intl.get('creditCare.modal.title'),
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.content,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles['preview-container'],
                    children: /*#__PURE__*/ _jsx("img", {
                        src: UsageNotifyImg,
                        alt: "",
                        className: styles['preview-image']
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.description,
                    dangerouslySetInnerHTML: {
                        __html: intl.get('creditCare.modal.description')
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.divider
                }),
                /*#__PURE__*/ _jsx(Button, {
                    className: styles['learn-more-button'],
                    type: "primary",
                    onClick: handleLearnMore,
                    children: intl.get('creditCare.modal.learnMore')
                })
            ]
        })
    });
}
